const createDynamicUpgradeQueryString = (userId, partnerId) =>
  new URLSearchParams({
    u: userId,
    p: partnerId,
    action: 'purchase',
    product: 'difm_privacy',
  }).toString();

export default createDynamicUpgradeQueryString;
